export default [
    /**
     * 登录
     * @query.from
     */
    {
        path: '/account/login',
        meta: {needLogin: false, title: '登录'},
        component: () => import('./views/login')
    },
    /**
     * 体检机构管理员登录
     * @query.from
     */
    {
        path: '/account/tj/login',
        meta: {needLogin: false, title: '体检机构管理员登录'},
        component: () => import('./views/tj/login')
    },/*replace*/
]
